import { FunctionComponent, useState } from "react";
import ModalFiltro from "../../../../components/modalFiltros";
import { Button, FormLabel, Grid, Input, Switch } from "@mui/material";
import { SelectSede } from "../../../../components/selects/sede";
import { useServicesMembroBatismo } from "../context/getServices";

interface ModalFilterProps {
}

const ModalFilterBatismo: FunctionComponent<ModalFilterProps> = () => {

  const {
    params,
    getWithParams,
    reset,
    alterParams } = useServicesMembroBatismo()

  const [date, setDate] = useState<any>();

  return (<>
    <ModalFiltro>
      <>
        <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, height: 50, borderBottom: '1px solid #ccc' }}>
          <h2>Filtros</h2>
        </section>

        <div style={{ display: 'grid',  padding: 4 }}>
          <SelectSede
            action={(value) => alterParams('idsede',value)}
            value={params?.idsede}
          />
          <Grid display='flex' alignItems={'center'}>
            <FormLabel>
              Ativo
            </FormLabel>
            <Switch defaultChecked={params?.ativo} onClick={() => alterParams('ativo', !params?.ativo)} />
          </Grid>
          <Grid display='flex' alignItems={'center'}>
            <FormLabel>
              Inscrição
            </FormLabel>
            <Input type='date' value={date} onChange={(event) =>
              {
                let date = event?.target?.value;
                let day = date.substring(8, 10);
                let year = date.substring(0, 4);
                let month = date.substring(5, 7);
                setDate(date);
                alterParams('inscricao', `${day}/${month}/${year}`);
              }
            } />
          </Grid>
        </div>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
          <Button
            onClick={reset}
            color="error"
          >
            Limpar
          </Button>
          <Button
            variant="contained"
            sx={{
              boxShadow: 'none'
            }}
            onClick={() => getWithParams()}
          >
            Enviar
          </Button>
        </div>
      </>
    </ModalFiltro>
  </>);
}

export default ModalFilterBatismo;
